import { Empty } from "antd";
import React from "react";
import ReceivablesList from "../ReceivablesList/ReceivablesList";
import SaleInfoSection from "../SaleInfoSection/SaleInfoSection";

const ReceivablesSection = ({ sale }) => (
  <SaleInfoSection title="Agenda de recebimento" minHeight={150}>
    <div className="container-table">
      {sale?.capabilities?.receivables ? (
        <ReceivablesList transactionId={sale?.id} totalAmount={sale?.amount} />
      ) : (
        <Empty description="Agenda de recebimento ainda não disponível para esta adquirente." />
      )}
    </div>
  </SaleInfoSection>
);

export default ReceivablesSection;
